import { useMutation, useQueryClient } from 'react-query';

import { deleteHubById as deleteHub } from 'api/traps/Hubs/deleteHub';

const useDeleteHub = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: getDeleteById,
    isLoading,
  } = useMutation(deleteHub, {
    onSuccess: () => {
      queryClient.invalidateQueries(['hubTable']);
    },
  });

  return {
    isSuccess,
    getDeleteById,
    isLoading,
  };
};

export default useDeleteHub;
